// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__0NgLA","loader_full":"loader_loader_full__JxNkZ","overlay":"loader_overlay__26M3R","flip":"loader_flip__Umcyf","s":"loader_s__VTkWN","m":"loader_m__X3JvR"};